import { render, staticRenderFns } from "./FinalStep.vue?vue&type=template&id=b73a4202&scoped=true"
import script from "./FinalStep.vue?vue&type=script&lang=js"
export * from "./FinalStep.vue?vue&type=script&lang=js"
import style0 from "./FinalStep.vue?vue&type=style&index=0&id=b73a4202&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b73a4202",
  null
  
)

export default component.exports